import { render, staticRenderFns } from "./07_deco_balance.vue?vue&type=template&id=29a8194d&scoped=true&"
import script from "./07_deco_balance.vue?vue&type=script&lang=js&"
export * from "./07_deco_balance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29a8194d",
  null
  
)

export default component.exports